import { PaginatedData } from 'app/types/PaginatedData';

export type PaginatedOrders = PaginatedData<Order>;

export interface Order {
  id: string;
  status: Status;
  srcFileId: string;
  srcFileShortPath: string;
  srcFileName: string;
  startedAt: string;
  amountOfSamples: number;
  executionTime: number | null;
  submittedBy: string;
  model: string;
  type: string;
  orgName: string;
  tags: Tag[];
  resultTypes?: {
    type: string;
    label: string;
  }[];
  canRequestPdf: boolean;
  virtual: boolean;
}

export enum Status {
  EMPTY = '',
  REGISTERED = 'Registered',
  PREPARING = 'Preparing',
  SUBMITTED = 'Submitted',
  RUNNING = 'Running',
  MODEL_COMPLETED = 'Model completed',
  COMPLETED = 'Completed',
  FAILED = 'Failed',
  CANCELED = 'Canceled',
  CANCELING = 'Canceling',
  QC_FAILED = 'QC failed',
  MAKING_REPORT = 'Making report',
  COLLECT_REPORT_RESULT = 'Collecting report results',
  REPORTS_FAILED = 'Reports failed',
}

export enum GroupStatus {
  EMPTY = '',
  INITIALIZING = 'initializing',
  RUNNING = 'running',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export interface Model {
  id: string;
  imageTag: string;
  fullImageTag: string;
  modelApiName: ModelApiName;
  imagePushedAt: string;
  imageDigest: string | null;
  createdAt: string;
  assignedName: string;
  gitCommit: string;
  clinicalValidated: boolean;
  validatedAt: string | null;
  validatedBy: string | null;
  description: string | null;
  executionResults: ExecutionResults;
  postExecutionResults: PostExecutionResults;
  isSandbox: boolean;
}

export interface ExecutionResults {
  resultSubPop: boolean;
  resultSubPopChrm: boolean;
  resultSuperPop: boolean;
  resultSuperPopChrm: boolean;
  resultSvgData: boolean;
  resultPrsData: boolean;
  resultPrsTechData: boolean;
  resultPrsQc: boolean;
}

export interface PostExecutionResults {
  ancestryPdfReport: boolean;
  prsRuoCardioPdfReport: boolean;
  prsRuoCancerPdfReport: boolean;
  prsClinicalCardioPdfReport: boolean;
  prsClinicalCancerPdfReport: boolean;
}

export interface ModelEcr {
  id: string;
  imageRegistry: string;
  imageRepository: string;
  imageTag: string;
  imageDigest: string;
  imagePushedAt: string;
  imageModels: ImageModel[];
}

export interface ImageModel {
  id: string;
  modelApiName: ModelApiName;
}

export type ModelApiName = 'vader' | 'skywalker' | 'hutt' | 'palpatine' | 'mysterio';

export interface ModelApi {
  value: ModelApiName;
  label: string;
}

export interface NamedModel {
  id: string;
  modelId: string;
  modelName: string;
  modelApiName: ModelApiName;
  modelImageTag: string;
  clinicalValidated: boolean;
  validatedAt: string | null;
  validatedBy: string | null;
  enabled: boolean;
  executionResults: ExecutionResults | null;
  postExecutionResults: PostExecutionResults | null;
  usedInOrgs: number;
  isSandbox: boolean;
  comment: string | null;
}

export interface NamedModelHistory extends NamedModel {
  historyId: number;
}

export interface Tag {
  id: string;
  name: string;
  orgId: string;
}

export type PaginatedTags = PaginatedData<Tag>;

export interface OrdersFilterParams {
  search: string;
  orgs: string[];
  status: Status;
  groupStatus: GroupStatus;
  tags: string[];
  model: string;
  modelApi: string;
  minDate: string;
  maxDate: string;
  type: string;
  ordersIds: string;
}

export interface ModelsFilterParams {
  search: string;
  model: string;
  modelApiNames: string[];
  namedModels: string[];
  isSandbox: string;
  isCv: string;
  pushDate: string;
}

export interface NamedModelsFilterParams {
  search: string;
  modelApiNames: string[];
  imageTag: string;
  isSandbox: string;
  isCv: string;
  isEnabled: string;
}
